module.exports = __webpack_public_path__ + "static/fonts/gt-america-standard-regular.2bb0886.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/gt-america-standard-regular.woff2
// module id = 1205
// module chunks = 0